export default __webpack_public_path__ + "static/media/walletLoader.32614549.gif";